import Base from './Base'

/**
 * http://yapi.tmeoa.com/project/5240/interface/api/cat_12361
 */
class CpTaskService extends Base {
  find(postData) {
    return this.post('/caimai_task/query_caimai_task', postData, { noEmpty: true })
  }

  findById(id) {
    return this.post('/caimai_task/query_caimai_task_by_task_id', { id })
  }

  save(postData) {
    return this.post('/caimai_task/save_caimai_task', postData)
  }

  search(postData) {
    return this.post('/caimai_task/get_buy_info', postData)
  }

  changeValid(postData) {
    return this.post('/caimai_task/save_task_status_change', postData)
  }

  fastRemind(postData) {
    return this.post('/caimai_task/put_email_msg', postData)
  }
}

export default new CpTaskService()
